import React from 'react'
import { BetInfo } from '@orbital/games-frontend-library'
import getBetInfo from './helper/betInfo'
// import BonusInfo from './BonusInfo'
import Title from '../footer/text/Title'

const BetInfoWrapper = ({ data, title, currency, precision }: any) => {
  const { BET_INFO } = getBetInfo(data, precision, currency, title)

  return (
    <>
      {data.bet !== '0' && (
        <>
          <Title text={title} />
          <BetInfo content={BET_INFO} />
        </>
      )}
    </>
  )
}

export default BetInfoWrapper
